/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BrandInputs */

const en_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand & Portfolio`)
};

const es_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca y Portafolio`)
};

const fr_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque et Portfolio`)
};

const de_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marke & Portfolio`)
};

const ja_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブランド＆ポートフォリオ`)
};

const zh_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌与作品集`)
};

const ar_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العلامة التجارية والأعمال`)
};

const id_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merek & Portofolio`)
};

const it_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand & Portfolio`)
};

const ru_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бренд и Портфолио`)
};

const pt_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca e Portfólio`)
};

const ko_brand = /** @type {(inputs: BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브랜드 및 포트폴리오`)
};

/**
* | output |
* | --- |
* | "Brand & Portfolio" |
*
* @param {BrandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const brand = /** @type {((inputs?: BrandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BrandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brand(inputs)
	if (locale === "es") return es_brand(inputs)
	if (locale === "fr") return fr_brand(inputs)
	if (locale === "de") return de_brand(inputs)
	if (locale === "ja") return ja_brand(inputs)
	if (locale === "zh") return zh_brand(inputs)
	if (locale === "ar") return ar_brand(inputs)
	if (locale === "id") return id_brand(inputs)
	if (locale === "it") return it_brand(inputs)
	if (locale === "ru") return ru_brand(inputs)
	if (locale === "pt") return pt_brand(inputs)
	return ko_brand(inputs)
});